import routerOptions0 from "/app/node_modules/nuxt/dist/pages/runtime/router.options";
const configRouterOptions = {
  scrollBehavior: undefined
}
export default {
...configRouterOptions,
...routerOptions0,
}